// src/modules/app-views/landingPages/pages/Document/tabs/AiConsumptionTab/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Card, Empty } from 'antd';
import { useDocumentContext } from 'components/core/DocumentProvider';
import SimpleLoadingArea from 'components/SimpleComponents/SimpleLoadingArea';
import translateX from 'utils/translateX';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const AiConsumptionTab = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { data, loading } = useDocumentContext();

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div className="container" style={{ position: 'relative', minHeight: 120 }}>
      <SimpleLoadingArea name="lpAiConsumption" isFetching={loading} data={data} />

      <Card title={<div className="text-muted">{translateX('ai_consumption')}</div>}>
        <Empty
          description={translateX('coming_soon')}
          style={{ padding: '40px 0' }}
        />
      </Card>
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default AiConsumptionTab;
